import React, { useState } from 'react'
import { ReactComponent as OrderDetails } from "../../../../assets/images/OrderDetails.svg"
import { ReactComponent as Ice } from "../../../../assets/images/ice.svg"
import { ReactComponent as Compliance } from "../../../../assets/images/compliance.svg"
import { ReactComponent as FinishedPro } from "../../../../assets/images/finishedPro.svg"
import { ReactComponent as LinkedRecipe } from "../../../../assets/images/linkedRecipe.svg"
import { ReactComponent as Timer } from "../../../../assets/images/timer.svg"
import { ReactComponent as Calculator } from "../../../../assets/images/calculator.svg"
import { Dropdown, Modal, TextComponent } from '../../../../components'
import { ReactComponent as Crossiant } from "../../../../assets/images/QrCrossiant.svg"
import styles from "./IconSidebar.module.css";
import CustomCalculator from '../../../../components/Calculator/CustomCalculator'
import StopWatch from '../../../../components/StopWatch/StopWatch'
import IceCalculatorModal from '../../../../components/IceCalculator/IceCalculator'
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";
import CheckBox from '../../../../components/Checkbox/CheckBox'
import { useNavigate } from 'react-router-dom'


const IconSidebar = () => {
  const navigate = useNavigate()
  const [DetailsOpen, setDetailsOpen] = useState("");
  const [finishedProduct, setFinishedProduct] = useState("");
  const [calculator, setCalculator] = useState("");
  const [isStopWatchOpen, setIsStopWatchOpen] = useState("");
  const [iceCalc, setIceCalc] = useState("");
  const [compliance, setCompliance] = useState("");
  const [isAllergen, setIsAllergen] = useState({
    value: "Allergen",
    id: 1
  })

  const options = [
    { id: 1, name: "HACCP" },
    { id: 2, name: "GMP" },
    { id: 3, name: "Allergen" },
  ];

  const DropDownOptions = [
    {
      id: 1,
      value: "Allergen",
    },
    {
      id: 2,
      value: "Peanuts",
    },
    {
      id: 3,
      value: "Dairy",
    },
    {
      id: 4,
      value: "Gluten",
    },
    {
      id: 5,
      value: "Margarine",
    },
  ];

  const [focused, setFocused] = useState(options[0]);

  const OrderDetailsList = [
    {
      id: 1,
      label: "Order Name",
      Value: "French Batard Batch",
    },
    {
      id: 2,
      label: "Total Batch Weight",
      Value: "1000 kg",
    },
    {
      id: 3,
      label: "Order Code",
      Value: "ORD-4589",
    },
    {
      id: 4,
      label: "Start Date & Time",
      Value: "01/09/2025 – 08:30 AM",
    },
    {
      id: 5,
      label: "Due Date & Time",
      Value: "1/09/2025 – 03:00 PM",
    },
    {
      id: 6,
      label: "Skill Level Required",
      Value: "Intermediate",
    },
    {
      id: 7,
      label: "Previous Station",
      Value: "Mixing",
    },
    {
      id: 8,
      label: "Next Station",
      Value: "Cooling",
    },
    {
      id: 9,
      label: "Assign Staff",
      Value: "John Smith, Emily Davis, Michael Brown Sarah , David Wilson,Laura Thompson",
    },
  ]
  const FinishedProductList = [
    {
      id: 1,
      label: "Description",
      Value: "light and airy with a thin crispy crust",
    },
    {
      id: 2,
      label: "Finished weight",
      Value: "528g",
    },
    {
      id: 1,
      label: "Finished Dimensions",
      Value: "20 x 10 x 9 cm",
    },
    {
      id: 1,
      label: "Final Color",
      Value: "ffffff White",
    },
    {
      id: 1,
      label: "Texture",
      Value: "Light interior, Crispy Crust",
    },
    {
      id: 1,
      label: "Batch Weight",
      Value: "200",
    },
    {
      id: 1,
      label: "Quantity per Batch",
      Value: "250",
    },
    {
      id: 1,
      label: "QC Check",
      Value: (
        <div>
          <Crossiant />
        </div>
      ),
    },
  ]

  const HACCP = {
    "01": "Confirm all ingredients are within expiry date",
    "02": "Verify ingredient temperature before mixing (if applicable)",
    "03": "Record lot numbers for traceability (if required)",
    "04": "Confirm mixing bowl and attachments are sanitized",
    "05": "Mixing speed and time match recipe instructions",
  };

  const GMP = {
    "01": "Hands washed before starting",
    "02": "Gloves worn and hairnet in place",
    "03": "No jewelry or loose accessories",
    "04": "Mixing station clean and dry",
    "05": "Tools sanitized and ready",
    "06": "No food or drink in the area",
  };

  const Allergen = {
    "01": "Verify ingredients/labels",
    "02": "Use dedicated tools",
    "03": "Schedule after allergen-free",
    "04": "Fresh gloves/aprons",
    "05": "Record “Contains Peanuts”",
    "06": "Inspect & document area",
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.IconCont}
        onClick={() => { setDetailsOpen(true) }}
      >
        <OrderDetails />
        <TextComponent
          className={styles.IconText}
          text={"Order Details"}
        />
      </div>
      <div className={styles.IconCont}
        onClick={() => { setFinishedProduct(true) }}
      >
        <FinishedPro />
        <TextComponent
          className={styles.IconText}
          text={"Finished Product Specification"}
        />
      </div>
      <div className={styles.IconCont}
        onClick={() => { setIceCalc(true) }}
      >
        <Ice />
        <TextComponent
          className={styles.IconText}
          text={"Ice Calculator"}
        />
      </div>
      <div className={styles.IconCont}
        onClick={() => { setCalculator(true) }}
      >
        <Calculator />
        <TextComponent
          className={styles.IconText}
          text={"Calculator"}
        />
      </div>
      <div className={styles.IconCont}
        onClick={() => { setIsStopWatchOpen(true) }}
      >
        <Timer />
        <TextComponent
          className={styles.IconText}
          text={"Countdown"}
        />
      </div>
      <div className={styles.IconCont} onClick={() => (navigate("/Training/ViewReciepe"))}>
        <LinkedRecipe />
        <TextComponent
          className={styles.IconText}
          text={"Linked Recipe"}

        />
      </div>
      <div className={styles.IconCont}
        onClick={() => { setCompliance(true) }}
      >
        <Compliance />
        <TextComponent
          className={styles.IconText}
          text={"Compliance"}
        />
      </div>



      {/* ////////////////////////Order Detail modal ///////////////// */}
      <Modal
        open={DetailsOpen}
        onCancel={() => { setDetailsOpen(false) }}
        className={styles.modalCont}
        title={"Order Detail"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        {OrderDetailsList.map((item) => (


          <div key={item.id} className={styles.row}>
            <div>
              <TextComponent
                className={styles.label}
                text={item.label}
              />
            </div>
            <div className={styles.Odvalue}>
              <TextComponent

                text={item.Value || "-"}
              />
            </div>



          </div>
        ))}

      </Modal>

      {/* //////////////////////// Finished Product Specification ///////////////// */}
      <Modal
        open={finishedProduct}
        onCancel={() => { setFinishedProduct(false) }}
        className={styles.modalCont}
        title={"Finished Product Specification"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        {Array.isArray(FinishedProductList) &&
          FinishedProductList.map((item) => (
            <div key={item.id} className={styles.row}>
              <TextComponent className={styles.label} text={item.label} />
              <div className={styles.value}>
                {item.Value ? item.Value : "-"}
              </div>
            </div>
          ))}
      </Modal>


      {/* //////////////////////// Calculator ///////////////// */}
      <Modal
        open={calculator}
        onCancel={() => { setCalculator(false) }}
        className={styles.modalCont}
        title={"Calculator"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <CustomCalculator />
      </Modal>


      {/* //////////////////////// Stop Watch ///////////////// */}
      <Modal
        open={isStopWatchOpen}
        onCancel={() => { setIsStopWatchOpen(false) }}
        className={styles.modalCont}
        title={"Countdown"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <StopWatch />
      </Modal>


      {/* ////////////////////////Ice Calculator///////////////// */}
      <Modal
        open={iceCalc}
        onCancel={() => { setIceCalc(false) }}
        className={styles.modalCont}
        title={"Ice Calculator"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <IceCalculatorModal />
      </Modal>

      {/* //////////////////////// Compliance ///////////////// */}
      <Modal
        open={compliance}
        onCancel={() => { setCompliance(false) }}
        className={styles.modalCont}
        title={"Compliance"}
        headingClass={styles.modalHeading}
        width={"400px"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >

        <div>
          <TopTabComponent
            options={options}
            focused={focused}
            setFocused={setFocused}
            TabStyle={styles.TabStyle}
            TabLabelColor={"--var(--white-color)"}
          />
        </div>
        {focused?.name === "HACCP" && (
          <div className={styles.itemsList}>
            {Object.entries(HACCP).map(([label, value]) => {
              const formattedLabel = label.replace(/_/g, " ");
              return (
                <div className={styles.InsCont}>
                  <div className={styles.inLineRow}>

                    <TextComponent
                      className={styles.instructionslabel}
                      text={`${formattedLabel} `}
                    />
                    <TextComponent
                      className={styles.instructionsvalue}
                      text={value || "-"}
                    />
                  </div>
                  <div>
                    <CheckBox onClick={onChange} />


                  </div>
                </div>
              );
            })}
          </div>

        )}
        {focused?.name === "GMP" && (
          <div className={styles.itemsList}>
            {Object.entries(GMP).map(([label, value]) => {
              const formattedLabel = label.replace(/_/g, " ");
              return (
                <div className={styles.InsCont}>
                  <div className={styles.inLineRow}>

                    <TextComponent
                      className={styles.instructionslabel}
                      text={`${formattedLabel} `}
                    />
                    <TextComponent
                      className={styles.instructionsvalue}
                      text={value || "-"}
                    />
                  </div>
                  <div>
                    <CheckBox onClick={onChange} />


                  </div>
                </div>
              );
            })}
          </div>
        )}

        {focused?.name === "Allergen" && (
          <div style={{ width: "100%" }}>
            <Dropdown
              inputClass={styles.Dropdown}
              placeholder={"Select Action"}
              value={isAllergen}
              options={DropDownOptions}
              onChange={(e) => setIsAllergen(e)}
            />


            <div className={styles.itemsList}>
              {Object.entries(Allergen).map(([label, value]) => {
                const formattedLabel = label.replace(/_/g, " ");
                return (
                  <div className={styles.InsCont}>
                    <div className={styles.inLineRow}>

                      <TextComponent
                        className={styles.instructionslabel}
                        text={`${formattedLabel} `}
                      />
                      <TextComponent
                        className={styles.instructionsvalue}
                        text={value || "-"}
                      />
                    </div>
                    <div>
                      <CheckBox onClick={onChange} />


                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Modal>

    </div>
  )
}

export default IconSidebar;